import { add } from 'date-fns';


import { _mock } from './_mock';
import { _tags } from './assets';

// ----------------------------------------------------------------------

const standort = [
  { code: '', label: '', phone: '' },
  { code: 'AD', label: 'Home-Office', phone: '376' },
];

const CONTENT = `

<h5>Das erwartet Dich bei uns</h5>
<br/>
<ul>
  <li>Mehrjährige Berufserfahrung in Entwicklungsprojekten</li>
  <li>Fortgeschrittene Kenntnisse von Angular, Electron, Ionic, React</li>
  <li>Fortgeschrittene Kenntnisse von PHP und relationalen Datenbanken</li>
  <li>Fortgeschrittene Kenntnisse von Javascript/Typescript, CSS/SCSS</li>
  <li>Grundkenntnisse in Spezifikation von Aufgaben, mindestens: Überführung von Spezifikationen/Anforderungen in Detailaufgaben</li>
  <li>Grundkenntnisse in GIT</li>
  <li>Teamfähigkeit</li>
  <li>Gute Deutsch- und Englischkenntnisse</li>
</ul>

<br/>
<br/>

<h5>Das bringst Du mit</h5>
<br/>
<ul>
  <li>Eine interessante und abwechslungsreiche Tätigkeit, ein angenehmes Arbeitsklima, unter flexiblen Rahmenbedingungen in einem motivierten Team</li>
  <li>Überdurchschnittliche Bezahlung + Jahressonderzahlungen wie Urlaubs- und Weihnachtsgeld</li>
  <li>Einen unbefristeten Arbeitsvertrag</li>
  <li>Flexible Arbeitszeiten und mobiles Arbeiten für eine ausgeglichene Work-Life-Balance</li>
  <li>Volle Rückendeckung für Familienmenschen und Unterstützungsangebote für alle</li>
  <li>Tolle Entwicklungschancen: vielfältige Weiterbildungen, Trainings und Workshops</li>
  <li>Ein Team, das zusammenhält und ein respektvolles Miteinander auf Augenhöhe arbeitet</li>
</ul>
`;

export const JOB_BENEFIT_OPTIONS = [
  { value: 'Free parking', label: 'Free parking' },
  { value: 'Bonus commission', label: 'Bonus commission' },
  { value: 'Travel', label: 'Travel' },
  { value: 'Device support', label: 'Device support' },
  { value: 'Health care', label: 'Health care' },
  { value: 'Training', label: 'Training' },
  { value: 'Health Insurance', label: 'Health Insurance' },
  { value: 'Retirement Plans', label: 'Retirement Plans' },
  { value: 'Paid Time Off', label: 'Paid Time Off' },
  { value: 'Flexible Work Schedule', label: 'Flexible Work Schedule' },
];

export const _jobs = [...Array(1)].map((_, index) => {
  const benefits = JOB_BENEFIT_OPTIONS.slice(0, 3).map((option) => option.label);

  const type = (index == 0 && 'Vollzeit') || 'teilzeit';

  const level = (index == 0 && 'Berufserfahrene') || 'student';

  const location = standort.map((option) => option.label)[index + 1];

  const languages = ['Deutsch', 'English'];

  const skills = _tags.slice(0, 5);

  const company = {
    name: _mock.companyName(index),
    logo: _mock.image.company(index),
  };

  const locationMap = [
    {
      address: _mock.fullAddress(index),
      phoneNumber: _mock.phoneNumber(index),
      email: _mock.email(index),
      latlng: [33, 65],
    },
  ];

  return {
    id: _mock.id(index),
    type,
    level,
    skills,
    company,
    benefits,
    location,
    languages,
    locationMap,
    content: CONTENT,
    createdAt: new Date(),
    experience: index + 1,
    category: _tags[index],
    slug: _mock.jobTitle(index),
    urgent: [1, 3].includes(index),
    favorited: [2, 4].includes(index),
    totalViews: _mock.number.nativeL(index),
    deadline: add(new Date(), { months: index }),
    salary: (index % 3 && 12000) || 'competitive',
    shareLinks: {
      facebook: `facebook/user-name`,
      instagram: `instagram/user-name`,
      linkedin: `linkedin/user-name`,
      twitter: `twitter/user-name`,
    },
  };
});

export const _jobsByCompanies = [...Array(1)].map((_, index) => ({
  id: _mock.id(index),
  name: _mock.companyName(index),
  logo: _mock.image.company(index),
  totalJobs: 101 + index,
}));

const ICONS = [
  '/assets/icons/ic_money.svg',
  '/assets/icons/ic_marketing_bullhorn.svg',
  '/assets/icons/ic_creativity.svg',
  '/assets/icons/ic_web_programming.svg',
  '/assets/icons/ic_chip.svg',
  '/assets/icons/ic_customer_service.svg',
  '/assets/icons/ic_stethoscope.svg',
  '/assets/icons/ic_banking.svg',
];

export const _jobsByCategories = [...Array(1)].map((_, index) => ({
  id: _mock.id(index),
  icon: ICONS[index],
  name: _mock.jobTitle(index),
  totalJobs: _mock.number.nativeM(index),
}));

export const _jobsByCountries = [...Array(1)].map((_, index) => ({
  id: _mock.id(index),
  coverUrl: _mock.image.travel(index),
  totalJobs: _mock.number.nativeM(index),
  location: standort.map((option) => option.label)[index + 1],
}));
